import { Progress as MantineProgress, ProgressProps } from '@mantine/core';

export type IProgressProps = ProgressProps;

/** @registry Design-layer pass-through over Mantine Progress; import this instead of @mantine/core Progress outside src/design. Compound statics (Progress.Section, Progress.Root, Progress.Label) are preserved. */
export const Progress = MantineProgress;
